// The sign-in steps (P1-E05). Tokens go to src/api/auth.ts (memory); the refresh cookie is the API's.
import { api, unwrap } from '@/api/client';
import { applyTokens, clearTokens, getMfaToken, type TokenOut } from '@/api/auth';
import { resetJobs } from '@/api/jobs';

/** POST /admin/auth/login → a session, the MFA step (`mfa_required`), or MFA enrolment (`mfa_setup_required`). */
export async function signIn(email: string, password: string): Promise<TokenOut> {
  const t = await unwrap(api.POST('/admin/auth/login', { body: { email: email.trim(), password } }));
  applyTokens(t);
  return t;
}

/** POST /admin/auth/mfa/setup (an Admin not enrolled yet, with the limited token): the secret to add. */
export function setupMfa() {
  return unwrap(api.POST('/admin/auth/mfa/setup'));
}

/** POST /admin/auth/mfa/verify: with the login's `mfa_token`, or with the bearer token when enrolling. */
export async function verifyMfa(code: string): Promise<TokenOut> {
  const mfaToken = getMfaToken();
  const t = await unwrap(api.POST('/admin/auth/mfa/verify', { body: { code: code.replace(/\s/g, ''), mfa_token: mfaToken } }));
  applyTokens(t);
  return t;
}

/** POST /admin/auth/logout (revokes the refresh cookie), then forgets everything in memory. */
export async function signOut(): Promise<void> {
  try {
    await api.POST('/admin/auth/logout');
  } finally {
    clearTokens();
    resetJobs();
  }
}
